import { css } from '@emotion/css';

import boxShadowMixin from '@editor2/styles/mixins/boxShadow';
import { colors } from '@editor2/styles/colors';
import { pageCommon } from '@editor2/styles/page';

export const chapterPage = css`
	${pageCommon}

	.tocTabs {
		a {
			color: ${colors.mainText};
			border-radius: 0;
		}

		.nav-link.disabled {
			background-color: ${colors.background};
		}
	}

	.nav-tabs .nav-link.active {
		border-top-color: white;
	}
`;

export const chapterEditorContainer = css`
	padding: 30px 40px;
	font-size: 14px;

	.chapterNumber {
		width: 150px;
	}

	.chapterCheckbox {
		label {
			font-size: 12px;
			color: ${colors.infoText};
		}
	}

	.chapterName {
		font-weight: 600;
		margin-bottom: 30px;
	}

	.chapterImageContainer {
		display: flex;
		justify-content: center;
		margin-bottom: 5px;

		.chapterImage {
			height: 125px;
		}
	}
`;

export const chapterSettings = css`
	padding: 30px 40px;
	font-size: 14px;

	.chapterTypeSelect {
		width: 200px;
	}
`;

export const toolsBlock = css`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-bottom: 20px;

	button {
		margin-left: 15px;
		font-size: 14px;
		border-color: ${colors.border};

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}
`;

export const contentTabStyle = css`
	padding: 20px 40px;
`;

export const contentBlock = css`
	color: ${colors.mainText};

	.addButton {
		font-size: 14px;
		margin-top: 15px;
		border-color: ${colors.border};
		background-color: inherit;
		color: ${colors.mainText};
		${boxShadowMixin(1)};

		svg {
			margin-right: 10px;
		}

		:hover {
			background-color: ${colors.background};
		}
	}
`;

export const pageGroupContainer = css`
	margin-bottom: 15px;

	.addPageButton {
		font-size: 14px;
		margin-top: 7px;
		margin-left: 30px;
		border-color: ${colors.border};
		background-color: inherit;
		color: ${colors.mainText};
		${boxShadowMixin(1)};

		svg {
			margin-right: 10px;
		}

		:hover {
			background-color: ${colors.background};
		}
	}

	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.listHidden {
		display: none;
	}

	.listShown {
		display: block;
	}
`;

export const pageContainer = css`
	margin-bottom: 15px;
`;

export const pageGroupPage = css`
	margin-left: 30px;
	padding: 3px 0;
	cursor: grab;
	position: relative;

	:hover {
		${boxShadowMixin(1)};

		.pageMenu {
			display: flex;
		}
	}

	a {
		color: ${colors.mainText};
	}

	a:hover {
		cursor: pointer;
		color: ${colors.hoverText};
		text-decoration: underline;
	}

	:not(:last-child) {
		border-bottom: 1px solid ${colors.border};
	}

	.pageMenu {
		position: absolute;
		left: -43px;
		top: 6px;
		padding: 0 10px;
		display: none;
		color: ${colors.mainText};

		svg:hover {
			cursor: pointer;
			background-color: ${colors.background};
		}
	}
`;

export const headerContainer = css`
	font-weight: 600;
	line-height: 1.2;
	background-color: ${colors.background};
	border-radius: 4px;
	padding: 12px 10px;
	margin-bottom: 5px;
	cursor: grab;
	position: relative;

	:hover {
		.menu {
			display: flex;
		}
	}

	.menu {
		position: absolute;
		left: -43px;
		top: 13px;
		padding: 0 10px;
		display: none;

		svg:hover {
			background-color: ${colors.background};
			cursor: pointer;
		}
	}

	.headerText {
		display: flex;
		align-item: center;
		justify-content: space-between;

		svg {
			cursor: pointer;
		}

		a {
			color: ${colors.mainText};
		}

		a:hover {
			cursor: pointer;
			text-decoration: underline;
		}

		span {
			color: ${colors.secondaryText};
		}
	}
`;

export const reorderBlock = css`
	padding: 20px 40px;
	color: ${colors.mainText};

	.pageElement {
		border: 1px solid ${colors.border};
		border-radius: 4px;
		margin-bottom: 5px;
		background-color: white;
		padding: 10px;

		.header {
			display: flex;
			justify-content: space-between;
		}

		.preview {
			font-size: 12px;
			color: ${colors.infoText};
		}
	}

	.indent {
		padding-left: 35px;
		border-left: 1px solid ${colors.background};
	}
`;
